
// import css from assets
import '../../assets/styles/footer.css';


const Footer = () => {

    return (
        <footer>
            <div>© Copyright @ 2022 Tabeeb Pvt. Ltd. - All Rights Reserved</div>
        </footer>
    );
    }

export default Footer;